var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowsOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 3h6v6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21H3v-6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 3l-7 7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21l7-7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowsOpened);
export default __webpack_public_path__ + "static/media/arrows-opened.3b78d3de60dc4a2c2d50e7fb542638dd.svg";
export { ForwardRef as ReactComponent };